import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr'

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(public toastr: ToastrService) { }
  
  showSuccess(message: any) {
    this.toastr.success(message, '', {
      timeOut: 3000,
      // closeButton: true,
    });
  }

  showError(message: any) {
    this.toastr.error(message, '', {
      timeOut: 3000,
    });
  }

  showInfo(message: any) {
    this.toastr.info(message, '', {
      timeOut: 3000,
    });
  }

  showWarning(message: any) {
    this.toastr.warning(message, '', {
      timeOut: 3000,
    });
  }
}
